module.exports = __webpack_public_path__ + "img/info_btn.3ae7b6c2.png";